// extracted by css-extract-rspack-plugin
export default {"main":"mwJvY","resizing":"Vlhk1"};